import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/salary-and-wages/_layout/')({
  beforeLoad: () => {
    throw redirect({
      to: '/salary-and-wages/reports'
    });
  }
});